import { Button } from "react-bootstrap";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddNewFieldButton = ({ btnText, isDisabled = false, handleClick }) => {
  const onAddNewClick = () => handleClick({ value: "" });
  return (
    <Button
      disabled={isDisabled}
      onClick={onAddNewClick}
      variant="outline-primary"
    >
      <FontAwesomeIcon icon={faAdd} className="me-2" />
      <span>{btnText}</span>
    </Button>
  );
};
export default AddNewFieldButton;
